const Images = {
    iconCarolus: require('./ic_carolus.png')
}

export default Images